var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, Stack } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { Text, Autocomplete } from "../../../../../Atoms";
import { ClearApplyButtons } from "../../../../../Common";
import { useIsMounted } from "../../../../../../hooks/useIsMounted";
import { AutocompleteOptionType } from "../../../../../Atoms/Inputs/Autocomplete";
var AutocompleteFilter = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, options = _a.options, onClear = _a.onClear, groupLabel = _a.groupLabel, _c = _a.multiple, multiple = _c === void 0 ? true : _c, onSubmit = _a.onSubmit, _d = _a.optionType, optionType = _d === void 0 ? AutocompleteOptionType.CheckBox : _d, actionRef = _a.actionRef, optionsLimit = _a.optionsLimit;
    var inputRef = useRef(null);
    var isMounted = useIsMounted();
    var defaultValue = options.filter(function (o) { return value.includes(o.id); });
    var _e = __read(useState(multiple ? defaultValue : (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[0]) || null), 2), selectedValue = _e[0], setSelectedValue = _e[1];
    // focus input on open
    useEffect(function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    /**
     * Clear filter if no items are selected, otherwise submit values
     */
    var handleSubmit = function () {
        if ((multiple && !(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.length)) ||
            (!multiple && !selectedValue)) {
            onClear();
        }
        else {
            if (multiple) {
                onSubmit(selectedValue.map(function (v) { return v.id; }));
            }
            else {
                onSubmit([selectedValue.id]);
            }
        }
    };
    /**
     * autocomplet is controlled, update controlled value on change
     */
    var handleChange = function (_, value) {
        setSelectedValue(value);
        setTimeout(function () {
            var _a;
            if (isMounted()) {
                (_a = actionRef === null || actionRef === void 0 ? void 0 : actionRef.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
            }
        }, 10);
    };
    /**
     * Clear values
     */
    var clear = useCallback(function () {
        handleChange(null, multiple ? [] : null);
    }, []);
    var hasValue = multiple
        ? selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.length
        : selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.id;
    return (_jsx(Stack, __assign({ alignItems: "center" }, { children: _jsxs(Stack, __assign({ maxWidth: 348, width: "100%" }, { children: [_jsx(Autocomplete, { options: options, onChangeCallback: handleChange, multiple: multiple, inline: true, open: true, maxHeight: 75, showSelectAll: multiple, textFieldProps: {
                        endAdornmentClick: hasValue ? clear : undefined,
                        inputRef: inputRef,
                    }, readOnly: false, value: selectedValue, optionsLimit: optionsLimit || 50, getOptionLabel: function (option) { return option.name; }, groupBy: groupLabel ? function () { return groupLabel; } : undefined, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, renderGroup: function (params) {
                        return (_jsxs(List, __assign({ sx: { pb: 0 } }, { children: [_jsx(Text, __assign({ ml: 4, variant: "overline", component: "p", emphasis: "disabled" }, { children: params.group })), _jsx(List, { children: params.children })] }), params.key));
                    }, optionType: optionType }), _jsx(ClearApplyButtons, { handleSubmit: handleSubmit, onClear: onClear })] })) })));
};
export default AutocompleteFilter;
